import {delay, noop} from 'lodash'
import {createLogger} from 'logging'
import {ITEM_TYPES} from 'powtoon-document/consts'

let timeouts

const logger = createLogger('userTrackingService')

const trackEventByParams = ({category, action, label, value, extraData}) => {
  if (process.env.NODE_ENV === 'production' && !window.trackEventByParams) {
    logger.error(new Error('window.trackEventByParams is missing in production.'))
  }
  const trackingFunc = window.trackEventByParams || noop
  return trackingFunc(category, action, label, value, extraData)
}

export const rudderStackTrackingService = {
  report(event) {
    const rsReport = event.rudderStackReportingOptions
    if (rsReport && window.rudderanalytics) {
      window.rudderanalytics.track(rsReport.event, rsReport.properties)
    }
  }
}

export const segmentTrackingService = {
  report(event) {
    const segmentReport = event.segmentReportingOptions
    if (segmentReport && window.analytics) {
      window.analytics.track(segmentReport.event, segmentReport.properties)
    }
  }
}

export const appcuesTrackingService = {
  report(event) {
    const appcuesReport = event.appcuesReportingOptions
    if (appcuesReport && window.Appcues) {
      window.Appcues.track(appcuesReport.event, appcuesReport.properties)
    }
  }
}

export const heapTrackingService = {
  report(event) {
    const heapReport = event.heapReportingOptions
    if (heapReport && window.heap) {
      window.heap.track(heapReport.event, heapReport.properties)
    }
  }
}

export default {
  report(eventObj) {
    trackEventByParams(eventObj)
  },

  logError: logger.error,

  trackEventByParams(category, action, label, value) {
    trackEventByParams({category, action, label, value})
  },
  setStoryBoardTimeSpentTracker() {
    timeouts = [0, 1, 2, 4, 15, 30, 90, 180, 360].map(
      min => delay(
        () => {this.trackEventByParams(`time_in_story_${min}_min`, 'duration', 'storyboard')},
        20000 * min
      )
    )
  },
  clearStoryBoardTimeSpentTracker() {
    timeouts.forEach(item => clearTimeout(item))
  },
  getSpriteType(sprite) {
    return sprite.assetType || (sprite.itemType === ITEM_TYPES.IMAGE ? 'images' : sprite.itemType)
  }
}
